export default __webpack_public_path__ + "static/media/cage.3df3d051.png";